export const EBAY_STICKY_CTA_ID = 'ebay_sticky_app_cta';

export const EBAY_STICKY_CTA_BRANCH_FEATURE = 'ebay_landing';
export const EBAY_STICKY_CTA_QR_REFERRER_SOURCE =
  'qr_code__ebay_sticky_app_cta';
export const EBAY_STICKY_CTA_DOWNLOAD_REFERRER_SOURCE =
  'download_button__ebay_sticky_app_cta';
